export default class ConversationSendOptinModel {
  sent!: boolean;

  alreadyAnswered!: boolean;

  needConfirmationToSend!: boolean;
}
